export default "__VITE_ASSET__BXDLVhaL__"